export default {
    Metadata: {
        Name: "CharIndex",
        Description: "Returns the index of a given character/string within a string.",
        Syntax: "CharIndex(search_string, find_string, startPos_number)",
        Keywords: ['String', 'Text'],
        Author: "DataVoke, Inc.",
    },
    execute(findStr, searchStr, intStartPos) //Overloaded (passed through)...EK
    {
        if (searchStr != null && findStr != null) {
            if (intStartPos == undefined) {
                intStartPos = 0;
            }

            if (typeof searchStr != 'string') {
                searchStr = searchStr.toString();
            }

            return searchStr.indexOf(findStr, intStartPos);
        }
        else {
            return -1;
        }
    },
};

